import ResizeObserver from 'resize-observer-polyfill';
import { useLayoutEffect, useState } from 'react';

const useResizeObserverRef = () => {
    const [observedNode, setObservedNode] = useState(null);
    const [firstEntry, setFirstEntry] = useState(null);
    const observer = new ResizeObserver(([entry]) => setFirstEntry(entry));
    useLayoutEffect(() => {
        observedNode && observer.observe(observedNode);
        return () => {
            observer.disconnect();
        };
    }, [observedNode]); //eslint-disable-line react-hooks/exhaustive-deps
    return [setObservedNode, firstEntry];
};

export default useResizeObserverRef;
